import { findClosestElementByAttr } from "../helpers/dom/closest";

export class Video {
	constructor(vidDomEl) {
		this.vidEl = vidDomEl;
		this.vidParent = this.vidEl.parentElement;
		this.ytVid = this.vidEl.tagName == "IFRAME" ? true : false;
		this.vid = this.ytVid
			? this.vidParent.querySelector("iframe")
			: this.vidParent.querySelector("video");

		// this.popupVidCont = findClosestElementByAttr(vidDomEl, 'data-popupVidCont');
		// this.popupVid = this.popupVidCont ? true : false;

		this.wcagCont = findClosestElementByAttr(vidDomEl, "data-wcag-video");
		this.bgVideo = this.wcagCont ? true : false;

		if (this.bgVideo) {
			if (isMobile) {
				this.vidParent.removeChild(this.vidEl);
			} else {
				this.videocontrol(this.wcagCont);
			}

			// else{

			// if (this.ytVid){

			// this.vidEl.src = this.vidEl.getAttribute('data-video');
			// this.vidEl.classList.add('show-video');

			// }else{

			// this.vidEl.querySelector('source').src =  this.vidEl.getAttribute('data-video');

			// this.vidEl.load();
			// this.vidEl.play();
			// this.vidEl.classList.add('show-video');
			// this.vidEl.onplaying = function(e){
			//     e.currentTarget.classList.add('show-video');
			// };

			// }

			// }
		}
	}
	videocontrol(wcag_cont) {
		const btn_play = wcag_cont.querySelector("[data-wcag-play]");
		const btn_pause = wcag_cont.querySelector("[data-wcag-pause]");
		const btn_replay = wcag_cont.querySelector("[data-wcag-replay]");

		if (this.ytVid) {
			if (btn_play) {
				btn_play.addEventListener("click", (e) => {
					this.vid.contentWindow.postMessage(this.message("playVideo"), "*");
				});
			}
			if (btn_pause) {
				btn_pause.addEventListener("click", (e) => {
					this.vid.contentWindow.postMessage(this.message("pauseVideo"), "*");
				});
			}
			if (btn_replay) {
				btn_replay.addEventListener("click", (e) => {
					this.vid.contentWindow.postMessage(this.message("playVideo"), "*");
					this.vid.contentWindow.postMessage(this.message("seekTo", [0]), "*");
				});
			}
		} else {
			if (btn_play) {
				btn_play.addEventListener("click", (e) => {
					this.vid.play();
				});
			}
			if (btn_pause) {
				btn_pause.addEventListener("click", (e) => {
					this.vid.pause();
				});
			}
			if (btn_replay) {
				btn_replay.addEventListener("click", (e) => {
					this.vid.currentTime = "0";
					this.vid.play();
				});
			}
		}
	}
	message(func) {
		return JSON.stringify({
			event: "command",
			func: func,
			args: [],
		});
	}
	stopVideo() {
		if (this.vid)
			if (this.ytVid) {
				this.vid.contentWindow.postMessage(this.message("stopVideo"), "*");
			} else {
				this.vid.currentTime = "0";
				this.vid.pause();
			}
	}
	playVideo() {
		if (this.vid)
			if (this.ytVid) {
				this.vid.contentWindow.postMessage(this.message("playVideo"), "*");
				this.vid.contentWindow.postMessage(this.message("seekTo", [0]), "*");
			} else {
				this.vid.currentTime = "0";
				this.vid.play();
				var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
				if (!iOS) {
					this.vid.addEventListener("touchstart", function (e) {
						e.currentTarget.play();
					});
				}
			}
	}
}
